module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-284.6a2294f.woff2";